import type { Camera, Scene, WebGLRenderer, WebGLRenderTarget } from '@seddi/three';
import { RenderPass } from '@seddi/three/addons/postprocessing/RenderPass.js';

export class ThreeMainRenderPass extends RenderPass {
  constructor(scene: Scene, camera: Camera) {
    super(scene, camera);
  }

  render(
    renderer: WebGLRenderer,
    writeBuffer: WebGLRenderTarget,
    readBuffer: WebGLRenderTarget,
    deltaTime: number,
    maskActive: boolean,
  ) {
    (renderer as any).applyDepthPeeling = true;

    super.render(renderer, writeBuffer, readBuffer, deltaTime, maskActive);

    (renderer as any).applyDepthPeeling = false;
  }
}
